import React from 'react'
import { Table, TableBody, TableCell, TableRow, TableHead, styled, Grid, Skeleton } from '@mui/material'
import { useTranslate } from 'react-admin'
import { isStatus } from 'src/components/pages/sales/reservation/helper/isStatus'
import { getDayWithTimeZone } from 'src/components/pages/sales/reservation/helper/getDay'
const StyledTable = styled(Table)({
  marginTop: '20px',
  borderCollapse: 'separate',
  borderSpacing: '0 10px',
  backgroundColor:'#f6f7ff',
  padding: '10px',
  borderRadius: '10px'
})

const StyledTableRow = styled(TableRow)({
  backgroundColor: '#F9FAFB',
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
})

const StyledTableCell = styled(TableCell)({
  padding: '10px 16px',
  textAlign: 'left',
  fontSize: '14px',
  color: '#333333',
})

const StyledStatusText = styled('span')(() => ({
  display: 'inline-block',
  padding: '2px 6px',
  borderRadius: '4px',
  fontWeight: 'bold',
  textAlign: 'center',
}))

export const HistoryTable = ({ history, loading }) => {
  const translate = useTranslate()

  return (
    <Grid container spacing={3}>
      <Grid item lg={8} sm={10} sx={12}>
        <StyledTable>
          <TableHead>
            <TableRow>
              <StyledTableCell>{translate('ra.field.pickup_date')}</StyledTableCell>
              <StyledTableCell>{translate('ra.field.general_state')}</StyledTableCell>
              <StyledTableCell>{translate('ra.field.flow_status')}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading
              ? Array.from({ length: 2 }).map((_, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>
                      <Skeleton variant='text' width='80%' height='40px' />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Skeleton variant='text' width='60%' height='40px' />
                    </StyledTableCell>
                    <StyledTableCell>
                      <Skeleton variant='text' width='70%' height='40px' />
                    </StyledTableCell>
                  </StyledTableRow>
                ))
              : history?.map((item, index) => (
                  <StyledTableRow key={index}>
                    <StyledTableCell>{getDayWithTimeZone(item?.date, true)}</StyledTableCell>
                    <StyledTableCell>
                      <StyledStatusText
                        style={
                          item?.general_status && {
                            ...isStatus('general_status', item?.general_status, true, false),
                          }
                        }
                      >
                        {item?.general_status ? translate(`ra.status.${item?.general_status}`) : '-'}
                      </StyledStatusText>
                    </StyledTableCell>
                    <StyledTableCell>
                      <StyledStatusText
                        style={
                          item?.flow_status && {
                            ...isStatus('flow_status', item?.flow_status, true, false),
                          }
                        }
                      >
                        {item?.flow_status ? translate(`ra.status.${item?.flow_status}`) : '-'}
                      </StyledStatusText>
                    </StyledTableCell>
                  </StyledTableRow>
                ))}
          </TableBody>
        </StyledTable>
      </Grid>
    </Grid>
  )
}


